import { effects } from 'redux-saga'

import {
  setQualification,
  setQualificationResults,
} from '../../modules/signupEdit/actions'

export default function* clearQualify() {
  yield effects.put.resolve(setQualification(null))
  yield effects.put.resolve(setQualificationResults({}))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/clearQualify.js